function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Check Thin"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 32,
  "data-height": 27,
  transform: "translate(0 2)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 3,
  strokeLinecap: "square",
  className: "iconic-property-stroke",
  fill: "none",
  d: "M29.5 2.5l-18.5 19.5-8.5-8.5"
}));

function SvgCheckThinMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "check-thin",
    className: "iconic iconic-check-thin iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckThinMd);
export default __webpack_public_path__ + "static/media/check-thin-md.f6abb88f.svg";
export { ForwardRef as ReactComponent };